import React, { useMemo } from 'react';
import { x } from '@xstyled/styled-components';
import { select } from '~/lib/select';
import { Chapter, TrainingState, useTrainingStore } from '../state';
import { Bar, Container } from './ProgressBar.styles';
import { t } from 'ttag';

const getIndex = (chapter: Chapter, position: number) =>
  Math.max(0, Math.min(chapter.sequenceCount, position - chapter.position));

const selector = (s: TrainingState) => select(s, 'items', 'activeItemPosition');

export const ProgressBar = () => {
  const { items, activeItemPosition } = useTrainingStore(selector);
  const segments = useMemo(
    () =>
      items
        .filter(i => i.kind === 'chapter')
        .map((c: Chapter) => ({
          id: c.id,
          length: c.sequenceCount,
          index: getIndex(c, activeItemPosition)
        })),
    [items, activeItemPosition]
  );

  const getPercentage = () => {
    let lengthSum = 0;
    let indexSum = 0;
    segments.forEach(segment => {
      lengthSum += segment.length;
      indexSum += segment.index;
    });
    return ((indexSum * 100) / lengthSum).toFixed(0);
  };

  if (activeItemPosition < 0) return null;

  return (
    <Container>
      {segments.map(s => (
        <Bar aria-hidden="true" key={s.id} flex={1}>
          <Bar bg="#FFF" opacity="0.4" />
          {s.index ? (
            <Bar
              bg="#FFF"
              w={`${(s.index * 100) / s.length}%`}
              marginTop="-4px"
            />
          ) : null}
        </Bar>
      ))}
      <x.span position="absolute" visibility="hidden">
        {`${getPercentage()}% ${t`of the course passed`}`}
      </x.span>
    </Container>
  );
};
